import { mapState } from 'vuex'
import { formatImageByImageMogr2 } from '@/utils/index.js'
import throttle from 'lodash/throttle'

export default {
  props: {
    post: Object
  },

  data () {
    return {
      params: {
        limit: 10,
        offset: 0
      },
      comments: [],
      total: 0,
      loading: false,
      loaded: false,
      loadEnd: false
    }
  },

  computed: {
    ...mapState(['pageData', 'isLogin', 'userInfo', 'setting', 'terminalType']),
    SEO () {
      return {
        title: this.post.title,
        keywords: this.post.keywords,
        description: this.post.summary,
        image:  formatImageByImageMogr2(this.post.banner),
        author: this.post.author.nickname
      }
    }
  },

  methods: {
    formatImageByImageMogr2,
    async fetchComments () {
      this.loading = true
      try {
        const res = await this.$http({
          url: '/series/article/comment/page/get',
          params: {
            series_id: this.pageData.series,
            article_id: this.post.id,
            // article_id: 72623,
            ...this.params
          }
        })
        if (res.error) throw new Error(res.msg)
        this.comments = this.comments.concat(res.data)
        this.total = res.total
        this.loadEnd = this.total <= this.params.offset + this.params.limit
        this.loaded = true
      } catch (error) {
        this.$toast({
          type: 'error',
          message: error.message
        })
      }
      this.loading = false
    },
    reachBottom: throttle(function () {
      const el = document.querySelector('html')
      if (Math.abs(el.scrollHeight - el.clientHeight - el.scrollTop) < 350) {
        this.loadMore()
      }
    }, 100),
    loadMore () {
      if (this.loading) return
      if (this.loadEnd) return
      this.params.offset += this.params.limit
      this.fetchComments()
    },
    scrollToComment () {
      const target = this.$refs.comments
      if (target && target.$el) {
        const { top } = target.$el.getBoundingClientRect()
        window.scrollTo({
          top: top - 70,
          behavior: 'smooth'
        })
      }
    }
  },

  created () {
    this.fetchComments()
  },

  mounted () {
    window.addEventListener('scroll', this.reachBottom)
  },

  destoryed () {
    window.removeEventListener('scroll', this.reachBottom)
  }
}
